import { Heading } from '@pretamanger/component-library'
import PropTypes from 'prop-types'
import Translation from '#src/common/components/translation'
import { ProductCount } from './styles'

export const SubCategoryTitle = ({ count, name }) => {
  const id = `subcategory-${name.replace(/\W/g, '')}`
  return (
    <>
      <Heading
        level='h4'
        styleOverride='headingXsLight'
        aria-describedby={id}
        data-testid='subcategory-title'
      >
        {name} <ProductCount aria-hidden='true'>({count})</ProductCount>
      </Heading>
      <p id={id} className='sr-only'>
        <Translation id='product.count' tokens={{ count: String(count) }} />
      </p>
    </>
  )
}

SubCategoryTitle.propTypes = {
  count: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
}
